export enum LocalStorageKeys {
  token = "@dash/auth-token",
  ephemeralToken = "@dash/ephemeral-auth-token",
  email = "anonymous-email",
  response_template = "response-template",
}

export class LocalStorage {
  [x: string]: any;
  private static instance: LocalStorage;

  private constructor() {}

  static getInstance(): LocalStorage {
    if (!LocalStorage.instance) {
      LocalStorage.instance = new LocalStorage();
    }
    return LocalStorage.instance;
  }


  get(key: LocalStorageKeys): string  | null {
    return localStorage.getItem(key);
  }

  set(key: LocalStorageKeys, value: string): void {
    localStorage.setItem(key, value);
  }

  clear(): void {
    localStorage.clear();
  }
}
